const debounce = (func, delay = 700) => function debounced(...args) {
  const context = this;
  // set on global to maintain a single pointer
  clearTimeout(window.debounce);
  window.debounce = setTimeout(() => func.apply(context, args), delay);
};

export default debounce;
